import { isConsoleLoggingEnabled } from './flags/monitoring-console-logging-enabled'
import type { MonitoringConfig, ProviderType } from './providers/types'
import { isProduction } from './utils'

const baseProviders: ProviderType[] = ['newrelic']

// Console logging enabled in development, or in production when flag is on
const getDefaultProviders = (): ProviderType[] => {
  const includeConsole = !isProduction() || isConsoleLoggingEnabled()
  return includeConsole ? [...baseProviders, 'console'] : baseProviders
}

let monitoringConfig: MonitoringConfig = {
  providers: getDefaultProviders(),
  providerConfig: {
    newrelic: {
      enabled: true,
    },
  },
}

export function getMonitoringConfig(): MonitoringConfig {
  return monitoringConfig
}

/**
 * Sets the monitoring configuration
 *
 * This should be called early in the application initialization,
 * before any error reporting occurs.
 *
 * @param config - Partial configuration to merge with defaults
 *
 * @example
 * ```typescript
 * // Use New Relic
 * setMonitoringConfig({
 *   providers: ['newrelic']
 * })
 *
 * // Disable all monitoring (useful for tests)
 * setMonitoringConfig({
 *   providers: ['noop']
 * })
 * ```
 */
export function setMonitoringConfig(config: Partial<MonitoringConfig>): void {
  monitoringConfig = {
    ...monitoringConfig,
    ...config,
    providerConfig: {
      ...monitoringConfig.providerConfig,
      ...config.providerConfig,
    },
  }
}

export function resetMonitoringConfig(): void {
  monitoringConfig = {
    providers: getDefaultProviders(),
    providerConfig: {
      newrelic: {
        enabled: true,
      },
    },
  }
}
